import { DocumentPage } from "../../components/layout/DocumentPage";
import { PageHeader } from "../../components/layout/PageHeader";
import { Reveal } from "../../components/motion/Reveal";
import { experiences } from "../../data/experience";
import styles from "./Experience.module.css";

export function Experience() {
  return (
    <DocumentPage id="experience" pageNumber={4}>
      <PageHeader
        eyebrow="04 / EXPERIENCE"
        title={"웹·모바일·외부 장비를 연결한 현장 시스템을 구축했습니다."}
        description="모바일 앱과 SDK, 웹 업무 시스템, 외부 장비 연동까지 다양한 현장 환경에서 운영되는 서비스를 개발해 왔습니다."
        wideDescription
      />
      <div className={styles.timeline}>
        {experiences.map((experience, index) => (
          <Reveal key={`${experience.company}-${experience.period}`} delay={index * 0.05} className={styles.job}>
            <span className={styles.period}>{experience.period}</span>
            <div className={styles.title}><h3>{experience.company}</h3><span>{experience.role}</span></div>
            <div className={styles.body}>
              <p>{experience.description}</p>
              <ul>{experience.highlights.map((item) => <li key={item}>{item}</li>)}</ul>
            </div>
          </Reveal>
        ))}
      </div>
    </DocumentPage>
  );
}
